import { createAction, props } from '@ngrx/store';
import { IContactData, IContactModel, IModelState } from '@partners/api';

export class ContactActions {
  static reset = createAction('[Contact] Reset State');
  static updateModel = createAction('[Contact] Update Model', props<{ model: IContactModel }>());
  static updateClubMembership = createAction('[Contact] Update Club Membership', props<{ modelState: IModelState }>());
  static load = createAction('[Contact] Load');
  static loadSuccess = createAction('[Contact] Load Success', props<{ data: IContactData }>());
  static loadFailure = createAction('[Contact] Load Failure', props<{ error: any }>());
  static submit = createAction('[Contact] Submit');
  static submitSuccess = createAction('[Contact] Submit Success', props<{ model: IContactModel }>());
  static submitFailure = createAction('[Contact] Submit Failure', props<{ error: any }>());
}
